import { createSlice } from "@reduxjs/toolkit";
import { getBannerList, saveBanner, deleteBanner } from "../controller/banner.controller";
import { Banner } from "../types/bannerType";
import { SaveResponse } from "../types/common";

interface BannerState {
  loading: boolean;
  list: Banner[];
  total: { pages: number; data: number };
  response: SaveResponse | null;
  error: string | null;
}

const initialState: BannerState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  response: null,
  error: null,
};

const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    resetBannerResponse: (state) => {
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBannerList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBannerList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getBannerList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data banner";
      })
      .addCase(saveBanner.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveBanner.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(saveBanner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan banner";
      })
      .addCase(deleteBanner.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetBannerResponse } = bannerSlice.actions;
export default bannerSlice.reducer;
